$(function() {
    var count = 50;
  $('.blog-wrap .content-wrap').each(function() {
      var thisText = $(this).text();
       var textLength = thisText.length;
        if (textLength > count) {
           var showText = thisText.substring(0, count);
           var insertText = showText += '…';
           $(this).html(insertText);
       };
   });
 });